<template>
  <div class="main" @mouseleave="(ismodalBox = false), (title = ''), (imgurl = '')" v-if="list">
    <div class="left">
      <li v-for="(item, index) in list" :key="item.id" @mouseenter="
        (ismodalBox = true),
        (active = index),
        (title = item.name),
        (imgurl = item.icon)
        ">
        <div style="display: flex; align-items: center">
          <img :src="item.icon" alt="" /><a :class="item.name == title ? 'active' : ''" href="javascript:void(0);">{{
            item.name }}</a>
        </div>
        <div class="leftIcon">>></div>
      </li>
    </div>
    <div class="center">
      <transition name="slide-fade">
        <div class="modalBox" v-if="ismodalBox" @mouseleave="(ismodalBox = false), (title = ''), (imgurl = '')">
          <div class="item">
            <div class="title">
              <img :src="imgurl" alt="" /><span>{{ title }}</span>
            </div>
            <li v-for="(item, index) in list[active].secondSubjectVOList" @click="toPath(item.id)">
              <a href="javascript:void(0);">{{ item.name }}</a>
            </li>
          </div>
        </div>
      </transition>
      <slideshow></slideshow>
      <div class="advantage">
        <li v-for="item in advantageList" :key="item.id">
          <div class="icon">
            <img :src="item.src" alt="" />
          </div>
          <p>{{ item.text }}</p>
        </li>
      </div>
    </div>
    <div class="right">
      <!-- 上模块: 支付宝扫码(横排) -->
      <div class="right-top">
        <div class="qrcode-box">
          <qrcode
            :logoSrc="$pageConfig.title == '魅租机' ?logo1:logo2"
            logoBackgroundColor="#999"
            :logoMargin="3"
            render-as="canvas"
            :margin="4"
            level="M"
            :correctLevel="3"
            :text="qrcode"
            :logoScale="0.25"
            :size="74"
          ></qrcode>
        </div>
        <div class="scan-info">
          <img :src="ossUrl + '/scan.png'" alt="" />
          <div class="scan-title">支付宝扫一扫</div>
          <p>享受0押租凭首月1元租产品</p>
        </div>
      </div>

      <!-- 下模块: 商家展示 + 平台协议 -->
      <div class="right-bottom">
        <div class="store-row">
          <img :src="ossUrl + '/store.png'" alt="" />
          <div class="store-right">
            <div class="store-title">魅租官方甄选商城</div>
            <div class="tags">
              <div class="tag tag-orange">
                <img :src="ossUrl + '/star.png'" alt="" />
                <div>认证商家</div>
              </div>
              <div class="tag tag-red">
                <img :src="ossUrl + '/ship.png'" alt="" />
                <div>极速发货</div>
              </div>
              <div class="tag tag-gray" style="padding-right: 2px" @click="openCaptchaDialog">
                <div>经营资质</div>
                <i class="el-icon-arrow-right tag-arrow"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="divider"></div>
        <div class="agreement-title">平台协议</div>
        <ul class="agreement-list">
          <li v-for="item in agreementList" :key="item.id" @click="openAgreement(item)">
            <span> 《{{ item.title || item.name || item.agreementName }}》</span>
            <i class="el-icon-arrow-right arrow"></i>
          </li>
        </ul>
      </div>

      <!-- 经营资质验证码弹窗(el-dialog 渲染到 body,不影响布局) -->
      <el-dialog
        :visible.sync="captchaVisible"
        width="500px"
        custom-class="captcha-dialog"
        :show-close="false"
        :close-on-click-modal="false"
      >
        <div class="captcha-close" @click="captchaVisible = false">×</div>
        <div class="captcha-body">
          <div class="captcha-img-box" @click="getCaptcha">
            <img v-if="captchaImg" :src="captchaImg" alt="验证码" />
            <span v-else>验证码加载中...</span>
          </div>
          <span class="captcha-refresh" @click="getCaptcha">看不清?换一张</span>
          <input
            class="captcha-input"
            v-model="captchaValue"
            placeholder="请输入验证码"
          />
          <button
            class="captcha-submit"
            :disabled="!captchaValue.trim()"
            @click="submitCaptcha"
          >提交</button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import slideshow from "@/components/pc/mzj_slideshow.vue";
import { createUuid } from "@/utils/index.js";
import { getAllSubject, getCaptcha as fetchCaptcha, postCaptcha, getAllOrderAgreement, getCompanyDetail } from "@/api/indexApi";
import Qrcode from "vue-qr";

// 图片CDN根路径
const ossUrl = "https://meizuly.oss-cn-shanghai.aliyuncs.com/xcxPic/website";
export default {
  name: "mzj_Main",
  components: {
    slideshow,
    Qrcode,
  },
  created() {
    // this.getList();
    // this.getSlideshow()
    this.qrcode =  `https://ds.alipay.com/?scheme=` +
        encodeURIComponent(
          `alipays://platformapi/startapp?appId=${this.$pageConfig.appId }&page=pages/index/index&query=linkId=60001`
        );
    this.getAgreementList();
    this.uuid = createUuid();
    console.log(this.uuid)
  },
  props: ['list'],//父组件传来的数据列表
  methods: {
    //根据id，跳转分类页
    toPath(id) {
      this.$router.push({
        path: "pc_subjectGoods",
        query: { getGoodsBySecondId: id },
      });
    },
    //获取平台协议列表(过滤隐私协议与用户授权协议)
    getAgreementList() {
      getAllOrderAgreement({ channel: "CREATE_ORDER" })
        .then((res) => {
          const list = (res.data && res.data.result) || [];
          this.agreementList = list.filter(
            (item) =>
              item.type !== "PRIVACY_AGREEMENT" &&
              item.type !== "USER_AUTHORIZATION_AGREEMENT"
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //点击协议,新标签打开pdf
    openAgreement(item) {
      if (item.filePath) window.open(item.filePath);
    },
    //打开经营资质弹窗
    openCaptchaDialog() {
      this.captchaVisible = true;
      this.captchaValue = "";
      this.captchaImg = "";
      this.getCaptcha();
    },
    //获取验证码
    async getCaptcha() {
      const res = await fetchCaptcha(this.uuid)
      this.captchaImg = res.data.result.image
    },
    //提交验证码,获取公司资质
    async submitCaptcha() {
      if (!this.captchaValue.trim()) return;
      const res = await postCaptcha(this.captchaValue, this.uuid)
      if(res.data.success){ 
        const sRes = await getCompanyDetail(this.uuid)
        const detail = sRes.data.result;
        if (detail.licencePhoto) window.open(detail.licencePhoto);
        this.captchaVisible = false;
      }
    },
  },

  data() {
    return {
      qrcode:'',
      logo1: require("@/assets/meizuji.jpg"),
      logo2: require("@/assets/hz.jpg"),
      //图片CDN根路径
      ossUrl,
      //平台协议列表(过滤后)
      agreementList: [],
      //经营资质弹窗显隐
      captchaVisible: false,
      //验证码图片
      captchaImg: "",
      //验证码输入值
      captchaValue: "",
      //模态框title
      title: "",
      imgurl: "",
      //模态框内容显示
      active: 0,
      //模态框默认关闭
      ismodalBox: false,
      //模态框假数据
      modalList: [
        "数据1",
        "数据2",
        "数据3",
        "数据4",
        "数据5",
        "数据6",
        "数据7",
        "数据8",
      ],
      //列表数据
      // list: [],
      //advantage列表
      advantageList: [
        { id: 1, text: '质量保证', src: "https://meizuly.oss-cn-shanghai.aliyuncs.com/xcxPic/website/zlbz.png" },
        { id: 2, text: '极致体验', src: "https://meizuly.oss-cn-shanghai.aliyuncs.com/xcxPic/website/gwc.png" },
        { id: 3, text: '售后无忧', src: "https://meizuly.oss-cn-shanghai.aliyuncs.com/xcxPic/website/sh.png" },
        { id: 4, text: '信用免押', src: "https://meizuly.oss-cn-shanghai.aliyuncs.com/xcxPic/website/zm.png" },
      ],
      uuid: ''
    };
  },
};
</script>
<style lang="scss" scoped>
.active {
  color: #e84534 !important;
}

.main {
  width: 1288px;
  height: 450px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .left {
    padding-top: 10px;
    width: 224px;
    height: 450px;
    background-color: white;
    border-radius: 24px;

    li {
      padding: 0 17px 0 15px;
      height: 43px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      img {
        width: 18px;
        height: 18px;
      }

      a {
        font-size: 18px;
        font-family: "微软雅黑";
        font-weight: 400;
        color: #333333;
        margin-left: 12px;
      }
    }

    .leftIcon {
      font-size: 18px;
      font-family: "微软雅黑";
      font-weight: 400;
      color: #333333;
    }
  }

  .center {
    position: relative;
    width: 758px;
    height: 450px;
    background-color: white;
    border-radius: 24px;
    overflow: hidden;

    .modalBox {
      position: absolute;
      width: 420px;
      height: 450px;
      background: #ffffff;
      z-index: 99;
      padding: 0 25px;
      // border: 1px solid rgba($color: #dadada, $alpha: 0.9);
      border: 2px solid rgba($color: #dadada, $alpha: 1);
      border-radius: 25px;

      .item a:hover {
        color: #e84534;
      }

      .item {
        .title {
          display: flex;
          align-items: center;

          img {
            width: 20px;
            height: 20px;
          }

          span {
            font-size: 18px;
            font-family: "微软雅黑";
            font-weight: 400;
            color: #333333;
            line-height: 37px;
            margin-left: 12px;
          }
        }

        li {
          float: left;
          margin-right: 10px;
          font-size: 16px;
          font-family: "微软雅黑";
          font-weight: 400;
          color: #333333;
          line-height: 37px;
        }
      }
    }

    .advantage {
      width: 758px;
      height: 46px;
      margin-top: 39px;
      display: flex;
      align-items: center;
      justify-content: space-around;

      li {
        width: 146px;
        height: 46px;
        background-color: rgba($color: #f78910, $alpha: 0.1);
        border-radius: 23px;
        display: flex;
        align-items: center;

        .icon {
          width: 36px;
          height: 36px;
          background: #f78910;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          margin-left: 8px;

          img {
            width: 20px;
            height: 20px;
          }
        }

        p {
          font-size: 16px;
          font-family: "微软雅黑";
          font-weight: 400;
          color: #ffa242;
          line-height: 24px;
          margin-left: 12px;
        }
      }
    }
  }

  .right {
    width: 280px;
    height: 450px;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    // ===== 上模块: 支付宝扫码(横排), 高 90px =====
    .right-top {
      height: 90px;
      padding: 0 14px;
      display: flex;
      align-items: center;
      overflow: hidden;
      border-radius: 18px;
      margin-bottom: 10px;
      background: #ffffff;
      .qrcode-box {
        margin-right: 16px;
        width: 74px;
        height: 74px;
        // 宽高由 :size 控制, 不给 canvas/img 设宽高, 避免拉伸发糊
        canvas,
        img {
          display: block;

        }
      }

      .scan-info {
        flex: 1;
        min-width: 0;
        img {
            width: 20px;
            height: 20px;
          }
        .scan-title {
          margin-top: 4px;
          font-size: 13px;
          line-height: 13px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #3a76f6;
        }
        p {
          margin-top: 4px;
          font-size: 11px;
          font-family: PingFang SC;
          font-weight: 500;
          color: rgba(0,0,0,0.55);
        }
      }
    }

    // ===== 下模块: 商家展示 + 平台协议 =====
    .right-bottom {
      flex: 1;
      min-height: 0;
      padding: 20px 16px 10px;
      display: flex;
      flex-direction: column;
      background: #ffffff;
      border-radius: 18px;

      .store-row {
        display: flex;
        align-items: center;

        img {
          width: 48px;
          height: 48px;
        }
      }
      .store-right{
        margin-left: 8px;
        .store-title{
          font-family: PingFang SC;
          font-weight: bold;
          font-size: 15px;
          color: rgba(0,0,0,0.95);
          line-height: 16px;
        }
      }
      .tags {
        display: flex;
        align-items: center;
        margin-top: 8px;
        flex-wrap: wrap;

        .tag {
          height: 20px;
          line-height: 20px;
          padding: 0 5px;
          margin-right: 6px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          font-size: 10px;
          font-family: PingFang SC;
          &:last-child{
            margin-right: 0;
          }
          img {
            width: 9px;
            height: 9px;
            margin-right: 2px;
          }

          &.tag-orange {
            background: #fff6ef;
            color: #cc5304;
          }

          &.tag-red {
            background: #fff1f1;
            color: #f51e29;
          }

          &.tag-gray {
            background: rgba(0, 0, 0, 0.04);
            color: rgba(0, 0, 0, 0.55);
            cursor: pointer;

            .tag-arrow {
              font-weight: bold;
              font-size: 10px;
              color: rgba(0, 0, 0, 0.55);
            }
          }
        }
      }

      .divider {
        height: 1px;
        background: rgba(0, 0, 0, 0.06);
        margin: 18px 0 12px;
      }

      .agreement-title {
        padding-left: 5px;
        margin-bottom: 5px;
        font-family: PingFang SC;
        font-weight: bold;
        font-size: 14px;
        color: rgba(0,0,0,0.95);
      }

      .agreement-list {
        flex: 1;
        min-height: 0;
        overflow-y: auto;

        li {
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          font-family: PingFang SC;
          font-weight: 500;
          font-size: 12px;
          color: rgba(0,0,0,0.55);
          &:hover {
            color: #e84534;
          }
          .arrow {
            font-weight: bold;
          }
        }
      }
    }
  }
}

/*
  进入和离开动画可以使用不同
  持续时间和速度曲线。
*/
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>

<style lang="scss">
/* 弹窗样式(非scoped): el-dialog 挂载在body下, scoped无法命中 */
.captcha-dialog {
  border-radius: 18px !important;
  overflow: hidden;
  .el-dialog__header{
    padding: 0;
  }
  .el-dialog__body {
    padding: 0;
    position: relative;
  }

  .captcha-close {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #f5f5f5;
    color: #999;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    cursor: pointer;
    z-index: 1;

    &:hover {
      background: #e5e5e5;
      color: #666;
    }
  }

  .captcha-title {
    padding-top: 28px;
    text-align: center;
    font-size: 16px;
    font-family: "微软雅黑";
    font-weight: 500;
    color: #333;
  }

  .captcha-body {
    padding: 28px 40px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .captcha-img-box {
      width: 240px;
      height: 120px;
      border: 1px solid #eee;
      border-radius: 4px;
      overflow: hidden;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 100%;
        display: block;
      }

      span {
        font-size: 12px;
        color: #999;
      }
    }

    .captcha-refresh {
      margin-top: 10px;
      font-size: 12px;
      font-family: "微软雅黑";
      color: #3a76f6;
      cursor: pointer;
    }

    .captcha-input {
      width: 180px;
      height: 44px;
      margin-top: 16px;
      padding: 0 14px;
      background: #f5f5f5;
      border: none;
      border-radius: 6px;
      font-size: 14px;
      outline: none;
      box-sizing: border-box;

      &::placeholder {
        color: #999;
      }
    }

    .captcha-submit {
      width: 350px;
      height: 54px;
      margin-top: 26px;
      background: #333;
      color: #fff;
      border: none;
      border-radius: 10px;
      font-size: 18px;
      cursor: pointer;

      &:disabled {
        background: rgba(51, 51, 51, 0.4);
        cursor: not-allowed;
      }
    }
  }
}
</style>
